module.exports = __webpack_public_path__ + "static/media/logo-dark.c05579f8.png";